import './PersonalInfo.scss';
import Store from 'state/Store';
import { connect } from 'react-redux';
import { getPersonalDetails } from 'state/personalDetails/PersonalDetailsSelectors';
import { setPersonalDetails } from 'state/personalDetails/PersonalDetailsActions';
import {
  setCanContinueFalse,
  setCanContinueTrue,
} from 'state/canContinue/CanContinueActions';
import { MCityList, MStateList, StateList, SuffixList } from 'utils/Content';
import React, { useEffect } from 'react';
import {
  beaconPattern,
  isRequiredValidAddress,
  isRequiredValidName,
  isRequiredValidUsAndNonUsPhoneNumber,
  isValidEmail,
  isValidMiddleName,
} from 'utils/Validation';
import { ReactComponent as QuestionMark } from 'assets/question.svg';
import {
  LFEBeaconDropdown,
  LFEBeaconInputField,
  LFEBeaconTooltip,
  LFEBeaconRadioGroup,
  LFEBeaconRadioButton,
} from 'components/shared/LFEBeaconComponents';

const PersonalInfo = ({ personalDetails }) => {
  const {
    nameRegex,
    emailRegex,
    numberOnlyRegex,
    addressOneRegex,
    addressTwoRegex,
    addressCityRegex,
    phoneNumberRegex,
  } = beaconPattern;
  const {
    pfName,
    pmName,
    plName,
    pSuffix,
    pPhoneNum,
    pPhoneNumFormatted,
    pEmail,
    pAddress: {
      pAddressMilitary,
      pAddressOne,
      pAddressTwo,
      pAddressCity,
      pAddressState,
      pAddressZip,
    },
  } = personalDetails;

  const handleInputChange = (id, event) => {
    if (event && event.target) {
      if (id.includes('pPhoneNumFormatted')) {
        Store.dispatch(
          setPersonalDetails(
            'pPhoneNumFormatted',
            event.target.value,
            id.includes('Address')
          )
        );
      } else {
        Store.dispatch(
          setPersonalDetails(id, event.target.value, id.includes('Address'))
        );
      }
    }
  };
  const handleBlur = (id, event) => {
    if (event && event.target && id) {
      if (id.includes('pPhoneNum')) {
        const inputField = document.getElementById('pPhoneNum');
        const inputFieldFormatStore = inputField.formatStore;
        const { unmaskedValue } = inputFieldFormatStore;
        if (unmaskedValue) {
          Store.dispatch(
            setPersonalDetails(id, unmaskedValue, id.includes('Address'))
          );
        }
      }
    }
  };
  const radioOnChange = (id, event) => {
    if (event && event.target && id) {
      if (id === 'typeOfAddress') {
        Store.dispatch(
          setPersonalDetails('pAddressMilitary', !pAddressMilitary, true)
        );
      }
    }
  };

  useEffect(() => {
    if (
      pfName &&
      isRequiredValidName(pfName) &&
      pPhoneNumFormatted &&
      isRequiredValidUsAndNonUsPhoneNumber(pPhoneNumFormatted) &&
      plName &&
      isRequiredValidName(plName) &&
      ((pmName && isValidMiddleName(pmName)) || !pmName) &&
      pEmail &&
      isValidEmail(pEmail) &&
      isRequiredValidAddress(
        pAddressMilitary,
        pAddressOne,
        pAddressTwo,
        pAddressCity,
        pAddressState,
        pAddressZip
      )
    ) {
      Store.dispatch(setCanContinueTrue());
    } else {
      Store.dispatch(setCanContinueFalse());
    }
  }, [
    pAddressCity,
    pAddressOne,
    pAddressState,
    pAddressTwo,
    pAddressZip,
    pEmail,
    pPhoneNum,
    pPhoneNumFormatted,
    personalDetails,
    pfName,
    plName,
    pmName,
    pSuffix,
    pAddressMilitary,
  ]);

  return (
    <div className="personal-details">
      <div className="dn-page-subtitle"
           data-testid="pfdetails-header">
        Personal details
      </div>
      <div className="personal-details-fields">
        <div className="personal-details-info">
          <LFEBeaconInputField id="pfName"
                               name="pfName"
                               data-testid="pfName"
                               className="dn-input-field pfName blocked_data"
                               value={pfName}
                               label="First name"
                               type="text"
                               pattern={nameRegex}
                               required={true}
                               maxlength="32"
                               min="2"
                               onBeaconInput={(event) => handleInputChange('pfName', event)}
                               errorsMap={{ required: 'Required', noMatchPattern: 'Invalid name' }}
          />
          <LFEBeaconInputField id="pmName"
                               data-testid="pmName"
                               className="dn-input-field pmName blocked_data"
                               value={pmName}
                               label="Middle name (optional)"
                               type="text"
                               pattern={nameRegex}
                               required={false}
                               maxlength="32"
                               min="1"
                               onBeaconInput={(event) => handleInputChange('pmName', event)}
                               errorsMap={{ noMatchPattern: 'Invalid name' }}
          />
        </div>
        <div className="personal-details-info">
          <LFEBeaconInputField id="plName"
                               data-testid="plName"
                               className="dn-input-field plName blocked_data"
                               value={plName}
                               label="Last name"
                               type="text"
                               pattern={nameRegex}
                               required={true}
                               maxlength="32"
                               min="2"
                               onBeaconInput={(event) => handleInputChange('plName', event)}
                               errorsMap={{ required: 'Required', noMatchPattern: 'Invalid name' }}
          />
          <LFEBeaconDropdown id="pSuffix"
                             data-testid="pSuffix"
                             className="dn-input-field pSuffix blocked_data"
                             required={false}
                             label="Suffix (optional)"
                             onBeaconChange={(event) => handleInputChange('pSuffix', event)}
                             value={pSuffix}
          >
            <option value={''} />
            {SuffixList.map((Suffix) => {
              return (
                <option value={Suffix}
                        key={`${Suffix}-pSuffix`}>
                  {Suffix}
                </option>
              );
            })}
          </LFEBeaconDropdown>
        </div>
        <div className="personal-details-info">
          <LFEBeaconInputField id="pPhoneNum"
                               data-testid="pPhoneNum"
                               className="dn-input-field pPhoneNum blocked_data"
                               value={pPhoneNumFormatted}
                               label="Phone number"
                               format="+{1} (000) 000-0000"
                               type="tel"
                               pattern={phoneNumberRegex}
                               required={true}
                               minlength="17"
                               maxlength="17"
                               onBeaconInput={(event) =>
              handleInputChange('pPhoneNumFormatted', event)
            }
                               onBeaconBlur={(event) => handleBlur('pPhoneNum', event)}
                               errorsMap={{
              required: 'Required',
              noMatchPattern: 'Minimum 10 required',
            }}
          />
          <LFEBeaconInputField id="pEmail"
                               data-testid="pEmail"
                               className="dn-input-field pEmail blocked_data"
                               value={pEmail}
                               label="Email"
                               type="email"
                               pattern={emailRegex}
                               required={true}
                               onBeaconInput={(event) => handleInputChange('pEmail', event)}
                               min="5"
                               errorsMap={{
              required: 'Required',
              noMatchPattern: 'Invalid Email',
            }}
          />
        </div>
        <span data-testid="address-type-title"
              className="address-type-title">
          Address type&nbsp;
          <span>
            <LFEBeaconTooltip orientation="vertical"
                              trigger="hover"
                              content="For situations with a non-US address, please contact us at 1-800-225-5132."
            >
              <QuestionMark />
            </LFEBeaconTooltip>
          </span>
        </span>
        <LFEBeaconRadioGroup className="submitter-address-radio-object"
                             id="typeOfAddress"
        >
          <LFEBeaconRadioButton className="address-radio"
                                name="us-address-radio"
                                id="typeOfAddressUS"
                                data-testid="typeOfAddressUS"
                                checked={!pAddressMilitary && pAddressMilitary !== null}
                                onBeaconChange={(event) => radioOnChange('typeOfAddress', event)}
                                label="US"
          ></LFEBeaconRadioButton>
          <LFEBeaconRadioButton className="address-radio"
                                name="military-address-radio"
                                id="typeOfAddressMil"
                                data-testid="typeOfAddressMil"
                                checked={pAddressMilitary}
                                onBeaconChange={(event) => radioOnChange('typeOfAddress', event)}
                                label="Military"
          ></LFEBeaconRadioButton>
        </LFEBeaconRadioGroup>
        <div className="personal-details-info-address">
          <LFEBeaconInputField id="pAddressOne"
                               data-testid="pAddressOne"
                               className="dn-input-field pAddressOne blocked_data"
                               value={pAddressOne}
                               label="Address 1"
                               type="text"
                               pattern={addressOneRegex}
                               required={true}
                               maxlength="35"
                               min="2"
                               onBeaconInput={(event) => handleInputChange('pAddressOne', event)}
                               errorsMap={{
              required: 'Required',
              noMatchPattern: 'Invalid address',
            }}
          />
          <LFEBeaconInputField id="pAddressTwo"
                               data-testid="pAddressTwo"
                               className="dn-input-field pAddressTwo blocked_data"
                               value={pAddressTwo}
                               label="Address 2 (optional)"
                               type="text"
                               pattern={addressTwoRegex}
                               required={false}
                               maxlength="35"
                               onBeaconInput={(event) => handleInputChange('pAddressTwo', event)}
                               min="2"
                               errorsMap={{ noMatchPattern: 'Invalid address' }}
          />
        </div>
        <div className="personal-details-info-city-state">
          {!pAddressMilitary && (
            <LFEBeaconInputField id="pAddressCity"
                                 data-testid="pAddressCity"
                                 className="dn-input-field pAddressCity blocked_data"
                                 value={pAddressCity}
                                 label="City"
                                 type="text"
                                 pattern={addressCityRegex}
                                 required={true}
                                 maxlength="35"
                                 min="2"
                                 onBeaconInput={(event) =>
                handleInputChange('pAddressCity', event)
              }
                                 errorsMap={{
                required: 'Required',
                noMatchPattern: 'Invalid address',
              }}
            />
          )}
          {!pAddressMilitary && (
            <LFEBeaconDropdown id="pAddressState"
                               data-testid="pAddressState"
                               className="dn-input-field pAddressState blocked_data"
                               required={true}
                               label="State"
                               value={pAddressState}
                               onBeaconChange={(event) =>
                handleInputChange('pAddressState', event)
              }
                               errorsMap={{ required: 'Required' }}
            >
              <option value={''} />
              {StateList.map((State) => {
                return (
                  <option value={State}
                          key={`${State}-pAddressState`}>
                    {State}
                  </option>
                );
              })}
            </LFEBeaconDropdown>
          )}
          {pAddressMilitary && (
            <LFEBeaconDropdown id="pAddressCity"
                               data-testid="pAddressCity"
                               className="dn-input-field pAddressCity blocked_data"
                               required={true}
                               label="City"
                               value={pAddressCity}
                               onBeaconChange={(event) =>
                handleInputChange('pAddressCity', event)
              }
                               errorsMap={{ required: 'Required' }}
            >
              <option value={''} />
              {MCityList.map((City) => {
                return (
                  <option value={City}
                          key={`${City}-pAddressCity`}>
                    {City}
                  </option>
                );
              })}
            </LFEBeaconDropdown>
          )}
          {pAddressMilitary && (
            <LFEBeaconDropdown id="pAddressState"
                               data-testid="pAddressState"
                               className="dn-input-field pAddressState blocked_data"
                               required={true}
                               label="State"
                               onBeaconChange={(event) =>
                handleInputChange('pAddressState', event)
              }
                               value={pAddressState}
                               errorsMap={{ required: 'Required' }}
            >
              <option value={''} />
              {MStateList.map((State) => {
                return (
                  <option value={State}
                          key={`${State}-pAddressState`}>
                    {State}
                  </option>
                );
              })}
            </LFEBeaconDropdown>
          )}
        </div>
        <div className="personal-details-info">
          <LFEBeaconInputField id="pAddressZip"
                               data-testid="pAddressZip"
                               className="dn-input-field pAddressZip blocked_data"
                               value={pAddressZip}
                               label="Zip code"
                               type="text"
                               pattern={numberOnlyRegex}
                               required={true}
                               maxlength="5"
                               onBeaconInput={(event) => handleInputChange('pAddressZip', event)}
                               min="5"
                               errorsMap={{
              required: 'Required',
              noMatchPattern: 'Invalid zip code (Numbers Only)',
            }}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  personalDetails: getPersonalDetails(state),
});

export default connect(mapStateToProps)(PersonalInfo);
